export class SituationFamiliale {
    id: number;
    name: string;
}


